/*
 * @Author: Daokai Huo
 * @Date: 2023-02-15 09:56:51
 * @LastEditTime: 2023-02-16 17:48:59
 * @Description: 保留小数位数指令
 */
const findEle = (parent, type) => {
	return parent.tagName.toLowerCase() === type ? parent : parent.querySelector(type)
}
const trigger = (el, type) => {
	const e = new Event(type, { bubbles: true, cancelable: true })
	el.dispatchEvent(e)
}
const decimal = {
	bind: function (el, { value = 2 }, vnode) {
		// console.log('进入指令-----')
		const $inp = findEle(el, 'input')
		el.$inp = $inp
		$inp.handle = function () {
			const val = $inp.value
			// 存在小数执行一下操作
			if (val.length > 1 && val.indexOf('.') > -1) {
				const valArr = val.split('.')
				const valStr = valArr[1].length > value ? val.substr(0, val.indexOf('.') + value + 1) : val
				$inp.value = valStr
			}
			trigger($inp, 'input')
		}
		$inp.addEventListener('keyup', $inp.handle)
	},
	unbind: function (el) {
		el.$inp.removeEventListener('keyup', el.$inp.handle)
	}

}
export default decimal
